import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import Modal from '@welldev-group/rcl-modal';
import Button from '@welldev-group/rcl-button';

const DowngradedFeatureDetailsModal = ({
  isVisible,
  title,
  subTitle,
  downgradedFeatureDetails,
  onCancelDowngrade,
  onOutsideClick,
}) => {
  const featureDecreased =
    downgradedFeatureDetails?.lessWorkspaces === null ||
    downgradedFeatureDetails?.lessWorkspaces > 0 ||
    downgradedFeatureDetails?.lessChannels === null ||
    downgradedFeatureDetails?.lessChannels > 0 ||
    downgradedFeatureDetails?.customDomainNotSupported ||
    downgradedFeatureDetails?.lessPhoneSupport;
  const downgradedFeatureListElement = (
    <div className="subscription-feature-details-modal__body-feature-details subscription-feature-details-modal__body-feature-details--downgrade">
      <div className="subscription-feature-details-modal__body-feature-details-title">
        {I18n.t('components.subscription.subscription_feature_details_modal.downgrade.body.title')}
      </div>
      <ul className="subscription-feature-details-modal__body-feature-details-list">
        {(downgradedFeatureDetails && downgradedFeatureDetails.lessWorkspaces === null) ||
        downgradedFeatureDetails?.lessWorkspaces > 0 ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item subscription-feature-details-modal__body-feature-details-list-item--downgrade">
            {downgradedFeatureDetails?.lessWorkspaces === null
              ? I18n.t(
                  'components.subscription.subscription_feature_details_modal.downgrade.body.unlimited_workspaces',
                )
              : I18n.t(
                  'components.subscription.subscription_feature_details_modal.downgrade.body.workspace',
                  {
                    count: downgradedFeatureDetails?.lessWorkspaces,
                  },
                )}
          </li>
        ) : null}
        {downgradedFeatureDetails?.lessChannels === null ||
        downgradedFeatureDetails?.lessChannels > 0 ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item subscription-feature-details-modal__body-feature-details-list-item--downgrade">
            {downgradedFeatureDetails?.lessChannels === null
              ? I18n.t(
                  'components.subscription.subscription_feature_details_modal.downgrade.body.unlimited_channels',
                )
              : I18n.t(
                  'components.subscription.subscription_feature_details_modal.downgrade.body.channel',
                  {
                    count: downgradedFeatureDetails?.lessChannels,
                  },
                )}
          </li>
        ) : null}
        {downgradedFeatureDetails?.lessPhoneSupport !== null ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item subscription-feature-details-modal__body-feature-details-list-item--downgrade">
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.downgrade.body.phone_support',
              {
                count: downgradedFeatureDetails?.lessPhoneSupport,
              },
            )}
          </li>
        ) : null}
        {downgradedFeatureDetails?.customDomainNotSupported ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item subscription-feature-details-modal__body-feature-details-list-item--downgrade">
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.downgrade.body.custom_domain',
            )}
          </li>
        ) : null}
      </ul>
    </div>
  );

  return (
    <Modal
      className="subscription-feature-details-modal"
      isVisible={isVisible}
      onOutsideClick={onOutsideClick}
    >
      <Modal.Content className="subscription-feature-details-modal__body" align="center">
        <Icon
          className="subscription-feature-details-modal__body-warning-icon"
          name="warning"
          showBGColor={true}
          color="warning"
        />
        <div className="subscription-feature-details-modal__body-greeting-text">{title}</div>
        <div className="subscription-feature-details-modal__body-success-text">{subTitle}</div>
        {featureDecreased ? downgradedFeatureListElement : null}
      </Modal.Content>
      <Modal.Footer className="subscription-feature-details-modal__footer">
        <Button
          size="small"
          type="primary"
          label={I18n.t(
            'components.subscription.subscription_feature_details_modal.downgrade.footer.link.cancel',
          )}
          onClick={onCancelDowngrade}
        />
        <Button
          size="small"
          type="default"
          label={I18n.t(
            'components.subscription.subscription_feature_details_modal.downgrade.footer.link.close',
          )}
          onClick={onOutsideClick}
        />
      </Modal.Footer>
    </Modal>
  );
};

DowngradedFeatureDetailsModal.defaultProps = {
  isVisible: false,
  title: '',
  subTitle: '',
  downgradedFeatureDetails: null,
  onCancelDowngrade: () => {},
  onOutsideClick: () => {},
};

DowngradedFeatureDetailsModal.propTypes = {
  isVisible: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  downgradedFeatureDetails: PropTypes.shape({
    lessWorkspaces: PropTypes.number,
    lessChannels: PropTypes.number,
    customDomainNotSupported: PropTypes.bool,
    lessPhoneSupport: PropTypes.bool,
  }),
  onCancelDowngrade: PropTypes.func,
  onOutsideClick: PropTypes.func,
};

export default DowngradedFeatureDetailsModal;
